export const CapacitorAppConfigs = {
	// === Vaya ===
	'com.vayadriving': {
		// This is the DEFAULT config (vayadriving)
		// !NOTE: If we ever want the DEFAULT_APP_CONFIG to be different than this, we must update the DEFAULT_APP_CONFIG const in shared/platform/frontend/utils/cachedBundleAppId.ts
		appId: 'com.vayadriving',
		appName: 'Vaya',
		server: {
			// MUST be same URL used in SHIM URL for plugins to load in prod
			url: 'https://admin.vayadriving.com/?bundleAppId=com.vayadriving',

			// url:
			// 	process.env.NODE_ENV === 'development'
			// 		? // !NOTE: ONLY DO THIS FOR TESTING
			// 		  // TODO: Add some sort to pre-commit hooks to not allow this URL when pushing to prod
			// 		  'https://vaya-dev-client.ngrok.io/?bundleAppId=com.vayadriving'
			// 		: 'https://admin.vayadriving.com/?bundleAppId=com.vayadriving',

			// !NOTE: ONLY DO THIS FOR TESTING
			// TODO: Add some sort to pre-commit hooks to not allow this URL when pushing to prod
			// url: 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.vayadriving',

			allowNavigation: [
				'vayadriving.com',
				'*.vayadriving.com',
				'*.vayavalet.io',
				'vaya-dev-client.ngrok.io',
				'vaya-dev-*.ngrok.io',
				'vaya-staging-client.ngrok.io',
			],
		},
		android: {
			path: 'capacitor/com.vayadriving/android',
		},
		ios: {
			path: 'capacitor/com.vayadriving/ios',
		},
	},
	// === Vaya Valet Residential ===
	// TODO: Not yet coded anywhere, but I know Andies has reported that it would be nice to have a distinct app that residents can install to request their car
	'io.vayavalet.residential': {
		appId: 'io.vayavalet.residential',
		appName: 'Vaya Residential',
		server: {
			url: 'https://app.vayavalet.io',
		},
	},
	// === Meet at the Mirror ===
	'com.meetatthemirror': {
		// NOTE: Had to add the .app suffix due to the Android suspension stupidity
		// UPDATE: 2025-07-10 Android said we can resubmit? Reverting to no .app suffix
		appId: 'com.meetatthemirror',
		// !NOTE: Using "The Mirror" to render shorter name on the home screen of the devices
		appName: 'The Mirror',
		server: {
			// MUST be same URL used in SHIM URL for plugins to load in prod
			url: 'https://app.meetatthemirror.com/?bundleAppId=com.meetatthemirror',

			// !NOTE: ONLY DO THIS FOR TESTING
			// TODO: Add some sort to pre-commit hooks to not allow this URL when pushing to prod
			// url: 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.meetatthemirror',

			// url:
			// 	process.env.NODE_ENV === 'development'
			// 		? // !NOTE: ONLY DO THIS FOR TESTING
			// 		  // TODO: Add some sort to pre-commit hooks to not allow this URL when pushing to prod
			// 		  'https://vaya-dev-client.ngrok.io/?bundleAppId=com.meetatthemirror'
			// 		: 'https://app.meetatthemirror.com/?bundleAppId=com.meetatthemirror',

			allowNavigation: [
				'meetatthemirror.com',
				'*.meetatthemirror.com',
				'*.meetatthemirror.io',
				'meetatthemirror-dev-client.ngrok.io',
				'meetatthemirror-dev-*.ngrok.io',
				'meetatthemirror-staging-client.ngrok.io',
				'vaya-dev-client.ngrok.io',
				'vaya-dev-*.ngrok.io',
				'vaya-staging-client.ngrok.io',
			],
		},
		android: {
			path: 'capacitor/com.meetatthemirror/android',
		},
		ios: {
			path: 'capacitor/com.meetatthemirror/ios',
		},
		// Note to future self:
		// - To get this to build, I had to remove "FirebaseCoreDiagnostics" from "Other Linker Flags"
		// - And also had to remove "CocoaLumberjack"
		//
		// The hooks system works as follows:
		// - preCapSync.removePackages: These packages are removed BEFORE cap sync so they
		//   don't get copied to the native project (MATM doesn't need valet-specific plugins)
		// - postCapSync: The cap-cli script automatically restores the removed packages
		//   at their ORIGINAL versions (captured from package.json before removal)
		//
		// This means you don't need to maintain hardcoded versions here - just list
		// the package names to exclude from the native sync.
		hooks: {
			preCapSync: {
				removePackages: [
					// Valet-specific plugins not needed for MATM
					'@capacitor-community/stripe-terminal',
					'cordova-plugin-stripe',
					'@transistorsoft/capacitor-background-fetch',
					'@transistorsoft/capacitor-background-geolocation',
					'@awesome-cordova-plugins/background-mode',
					'cordova-plugin-background-mode',
					// MATM-1556: these two declare no Gradle `namespace`, which
					// AGP 8 requires, so leaving them in the native sync makes
					// every MatM Android build fail at configure time
					// ("Namespace not specified"). Neither is used by MatM
					// (http's only caller sits behind a hardcoded isNativeApp =
					// false; keep-awake has no JS consumer). Same exclusion as
					// com.johnoberg.app below. http has no fixed upstream release.
					'@capacitor-community/http',
					'@capacitor-community/keep-awake',
				],
			},
			// postCapSync is handled automatically by cap-cli.ts -
			// it restores packages at their captured versions
		},
	},
	// === Precina ===
	'com.precina.app': {
		appId: 'com.precina.app',
		appName: 'Precina',
		server: {
			// url: 'https://my.precina.com',
			// MUST be same URL used in SHIM URL for plugins to load in prod
			url: 'https://app.precina.com/?bundleAppId=com.precina.app',
			// url: 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.precina.app',
			allowNavigation: [
				'precina.com',
				'*.precina.com',
				'*.precina.io',
				'precina-dev-client.ngrok.io',
				'precina-dev-*.ngrok.io',
				'precina-staging-client.ngrok.io',
				'vaya-dev-client.ngrok.io',
				'vaya-dev-*.ngrok.io',
				'vaya-staging-client.ngrok.io',
			],
		},
		android: {
			path: 'capacitor/com.precina.app/android',
		},
		ios: {
			path: 'capacitor/com.precina.app/ios',
		},
		// The hooks system works as follows:
		// - preCapSync.removePackages: These packages are removed BEFORE cap sync so they
		//   don't get copied to the native project (Precina doesn't need valet-specific plugins)
		// - postCapSync: The cap-cli script automatically restores the removed packages
		//   at their ORIGINAL versions (captured from package.json before removal)
		hooks: {
			preCapSync: {
				removePackages: [
					// Valet-specific plugins not needed for Precina
					'@capacitor-community/stripe-terminal',
					'cordova-plugin-stripe',
					'@transistorsoft/capacitor-background-fetch',
					'@transistorsoft/capacitor-background-geolocation',
				],
			},
			// postCapSync is handled automatically by cap-cli.ts -
			// it restores packages at their captured versions
		},
	},
	// === Avatar Sharing Christ ===
	'com.asc': {
		appId: 'com.asc',
		appName: 'Avatar',
		server: {
			// MUST be same URL used in SHIM URL for plugins to load in prod
			url:
				process.env.NODE_ENV === 'development'
					? // !NOTE: ONLY DO THIS FOR TESTING
					  'https://vaya-dev-client.ngrok.io/?bundleAppId=com.asc'
					: 'https://app.avatarsharingchrist.com/?bundleAppId=com.asc',
			allowNavigation: [
				'avatarsharingchrist.com',
				'*.avatarsharingchrist.com',
				'vaya-dev-client.ngrok.io',
				'vaya-dev-*.ngrok.io',
				'vaya-staging-client.ngrok.io',
			],
		},
		android: {
			path: 'capacitor/com.asc/android',
		},
		ios: {
			path: 'capacitor/com.asc/ios',
		},
		// The hooks system works as follows:
		// - preCapSync.removePackages: These packages are removed BEFORE cap sync so they
		//   don't get copied to the native project (ASC doesn't need valet-specific plugins)
		// - postCapSync: The cap-cli script automatically restores the removed packages
		//   at their ORIGINAL versions (captured from package.json before removal)
		hooks: {
			preCapSync: {
				removePackages: [
					// Valet-specific plugins not needed for ASC
					'@capacitor-community/stripe-terminal',
					'cordova-plugin-stripe',
					'@transistorsoft/capacitor-background-fetch',
					'@transistorsoft/capacitor-background-geolocation',
					'@awesome-cordova-plugins/background-mode',
					'cordova-plugin-background-mode',
				],
			},
			// postCapSync is handled automatically by cap-cli.ts -
			// it restores packages at their captured versions
		},
	},
	// === Business Coach ===
	// !LEGACY BUNDLE ID! DO NOT USE!
	// 'com.businesscoach': {
	// 	appId: 'com.businesscoach',
	// 	appName: 'Business Coach',
	// 	server: {
	// 		url:
	// 			process.env.NODE_ENV === 'development'
	// 				? 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.businesscoach'
	// 				: 'https://admin.vayadriving.com/?bundleAppId=com.businesscoach',
	// 		allowNavigation: [
	// 			'vayadriving.com',
	// 			'*.vayadriving.com',
	// 			'vaya-dev-client.ngrok.io',
	// 			'vaya-dev-*.ngrok.io',
	// 			'vaya-staging-client.ngrok.io',
	// 		],
	// 	},
	// },
	// === Business Coach ===
	// !USE THIS FOR managed-apps/business-coach!
	'com.johnoberg.app': {
		appId: 'com.johnoberg.app',
		appName: 'John Oberg',
		server: {
			// MUST be same URL used in SHIM URL for plugins to load in prod
			url: 'https://app.johnoberg.com/?bundleAppId=com.johnoberg.app',

			// !NOTE: ONLY DO THIS FOR TESTING
			// TODO: Add some sort to pre-commit hooks to not allow this URL when pushing to prod
			// url: 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.johnoberg.app',

			// !NOTE! ONLY FOR TEMP INVESTIGATION by agent bcage_0r4vy4cwxz2s7gnxlhej5x9as
			// url: 'https://bc-boot-investigate.ngrok.io/?bundleAppId=com.johnoberg.app',

			// url:
			// 	process.env.NODE_ENV === 'development'
			// 		? 'https://vaya-dev-client.ngrok.io/?bundleAppId=com.johnoberg.app'
			// 		: 'https://admin.vayadriving.com/?bundleAppId=com.johnoberg.app',
			allowNavigation: [
				'vayadriving.com',
				'*.vayadriving.com',
				'*.johnoberg.com',
				'vaya-dev-client.ngrok.io',
				'vaya-dev-*.ngrok.io',
				'vaya-staging-client.ngrok.io',
			],
		},
		android: {
			path: 'capacitor/com.johnoberg.app/android',
		},
		ios: {
			path: 'capacitor/com.johnoberg.app/ios',
		},
		// Note to future self:
		// - To get this to build, I had to remove "FirebaseCoreDiagnostics" from "Other Linker Flags"
		// - And also had to remove "CocoaLumberjack"
		//
		// The hooks system works as follows:
		// - preCapSync.removePackages: These packages are removed BEFORE cap sync so they
		//   don't get copied to the native project (MATM doesn't need valet-specific plugins)
		// - postCapSync: The cap-cli script automatically restores the removed packages
		//   at their ORIGINAL versions (captured from package.json before removal)
		//
		// This means you don't need to maintain hardcoded versions here - just list
		// the package names to exclude from the native sync.
		hooks: {
			preCapSync: {
				removePackages: [
					// Valet-specific plugins not needed for MATM
					'@capacitor-community/stripe-terminal',
					'cordova-plugin-stripe',
					'@transistorsoft/capacitor-background-fetch',
					'@transistorsoft/capacitor-background-geolocation',
					'@awesome-cordova-plugins/background-mode',
					'cordova-plugin-background-mode',
					// 2026-07-24: dead Capacitor-3/5-era plugins whose android
					// build.gradle pins ancient AGP (3.6.1 / 7.2 / 8.0) in a
					// `buildscript {}` block. Under Gradle 8.11.1 these fail to
					// configure ("Could not create LibraryVariantBuilderImpl" /
					// Kotlin BuildFlowService isolation), breaking the Android
					// AAB build. None are used by the John Oberg webview shell
					// (http -> Capacitor core CapacitorHttp; dynamic-links is a
					// deprecated Firebase service; keep-awake unused). Excluding
					// them from the native sync is what makes bundleRelease green.
					'@capacitor-community/http',
					'@capacitor-community/keep-awake',
					'@pantrist/capacitor-firebase-dynamic-links',
				],
			},
			// postCapSync is handled automatically by cap-cli.ts -
			// it restores packages at their captured versions
		},
	},
};

// module.exports = {
// 	DEFAULT_APP_CONFIG,
// 	CapacitorAppConfigs,
// };
